import { ILookup, useFormLookups } from "@ngt/opms";

export const useEConsentFormLookups = (lookups?: ILookup[], contextLookups?: ILookup[]) => {
    const lookupsToUse = lookups ?? contextLookups;

    return useFormLookups(lookupsToUse);
};

export default useEConsentFormLookups;